import { ROUTE_PATHS } from "../types/RoutePaths";

const useNewDesign = process.env.REACT_APP_FEATURE_NEW_DESIGN === "true";

export const getAppHomePath = (): string => (useNewDesign ? ROUTE_PATHS.ADVERTISERS_LIST : ROUTE_PATHS.DASHBOARD);
